import { render, staticRenderFns } from "./ot_surveillance.vue?vue&type=template&id=36d29616&"
import script from "./ot_surveillance.vue?vue&type=script&lang=js&"
export * from "./ot_surveillance.vue?vue&type=script&lang=js&"
import style0 from "./ot_surveillance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports